import Female from './assets/Female.svg'
import Male from './assets/Male.svg'


export const images = {
    Female,
    Male
}